import { History, Location } from 'history';
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { login_url } from 'mk/urls/functions';
import { makeAbsoluteUrl } from 'mk2/helpers/urls';
import { UserEntity } from 'mk2/schemas';
import { redirectInPWA } from 'mk2/services/browserHistory';
import * as React from 'react';

// every component where @authOnly() decorator is applied must contain these attributes
interface AuthOnlyProps {
    requestUser: UserEntity;
    history: History;
    location: Location;
}

/**
 * Decorator enforcing that request user is authenticated. Otherwise it redirects to login page.
 *
 * Used on React.Component e.g.
 *
 * @authOnly()
 * class MyComponent extends React.Component {
 *     ...
 * }
 *
 * @returns decorator
 */
// tslint:disable-next-line:ban-types
export function authOnly(): <P, C extends Function>(WrappedComponent: C & React.ComponentClass<P & AuthOnlyProps>) => C {
    return (WrappedComponent) => {
        class AuthOnlyHoC extends React.Component<AuthOnlyProps> {
            public componentWillMount() {
                const { history, location, requestUser } = this.props;

                // check before mounting, so that we redir only once (not on each re-render)
                if (!isAuthenticated(requestUser)) {
                    const loginUrl = login_url({next: `${location.pathname}${location.search}`});
                    const gotoUrl = makeAbsoluteUrl(loginUrl); // absolutne url, lebo zatial musime ist mimo PWA
                    redirectInPWA(history, gotoUrl, 401);
                }
            }

            public render() {
                return isAuthenticated(this.props.requestUser) ? <WrappedComponent {...this.props as any} /> : null;
            }
        }
        return AuthOnlyHoC as any;
    };
}
